// removed by extract-text-webpack-plugin
module.exports = {"published":"osN8lNJKpGXvGC59Lcz8_","frontpage":"_33h23eSoZsQXJESy31FHLf","horizontal":"_3zRh5N9DYa3vw-ThSQ0jSa","-is-feature-article":"j3ppM1ldJC6SjnsNJXxB1","icon":"r3UTXDtRpSmP_CnBzvg85","text":"_3-c_nXIMx-xgeLcPZASoCn"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Published/Published.module.scss
// module id = 801
// module chunks = 0